import { useCallback, useContext } from 'react';
import { BUYING_PATH, GLOBAL_MESSAGING } from 'data/global';
import { getBuyingPortfolio, getSellingPortfolio } from 'utils';
import { useLocation } from 'react-router-dom';
import MessagingContext from '../providers/Messaging/Messaging.context';

export default function useMessagingNavigation() {
  const { messagingPortfolioProps } = useContext(MessagingContext);

  const isBuying = useLocation().pathname.includes(BUYING_PATH);

  return useCallback(
    (sessionId = '') => {
      if (!messagingPortfolioProps) return `${GLOBAL_MESSAGING}/${sessionId}`;

      const { dealRoomId, listingEnquiryId } = messagingPortfolioProps;

      if (isBuying)
        return `${getBuyingPortfolio(
          listingEnquiryId,
          'messaging',
        )}/${sessionId}`;

      return `${getSellingPortfolio(dealRoomId, 'messaging')}/${sessionId}`;
    },
    [isBuying, messagingPortfolioProps],
  );
}
